export const BLIND_STATUS = {
  NOT_BLIND: 0,
  BLIND: 1
};
